/**
 * BODi Auth Link Redirect URL Handler
 *
 * Adds redirectUrl parameter to all BODi auth links:
 * - Login: redirects to Shopify customer authentication page with return path
 * - Logout: redirects to Shopify logout page (/account/logout or /fr/account/logout)
 */
(function () {
  // Get locale from HTML lang attribute (e.g., 'en', 'fr', 'es')
  const locale = document.documentElement.lang.split('-')[0];
  
  // Get account domain for logout redirect
  let accountDomain = window.location.origin;
  if (!location.hostname.includes('account.')) {
    accountDomain = location.origin.replace('https://', 'https://account.');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bodi-auth-link]').forEach(function (link) {
      try {
        const url = new URL(link.href);
        const isLogout = url.pathname.includes('/logout');

        if (isLogout) {
          // For logout, redirect to Shopify Account logout page with locale prefix for French
          const shopifyLogoutPath = locale === 'fr' ? '/logout?locale=fr' : '/logout';
          const redirectUrl = accountDomain + shopifyLogoutPath;
          url.searchParams.set('redirectUrl', redirectUrl);
        } else {
          // For login, redirect to Shopify customer authentication page with return path
          const returnPath = window.location.pathname + window.location.search;
          const loginUrl = new URL('/customer_authentication/login', window.location.origin);
          loginUrl.searchParams.set('return_to', returnPath);
          url.searchParams.set('redirectUrl', loginUrl.toString());
        }

        link.href = url.toString();
      } catch (e) {
        // Silently fail if URL parsing fails
        console.warn('Failed to add redirectUrl to auth link:', e);
      }
    });
  });
})();
